module.exports = __webpack_public_path__ + "static/media/my_booking.f474ae9d.svg";